import moment from "moment";

type LeaveRequest = {
  startDate: string | Date;
  endDate: string | Date;
  leaveType: string;
  state?: string;
};

export const myLeaveCoverage = (
  {
    startDate,
    endDate,
    leaveType,
  }: { startDate: string | Date; endDate: string | Date; leaveType: string },
  leaveRequests: LeaveRequest[],
) => {
  const mainStart = moment(startDate).startOf("day");
  const mainEnd = moment(endDate).endOf("day");

  if (leaveType === "O") {
    const hasOverlappingO = leaveRequests.some((item) => {
      if (item.leaveType !== "O") return false;
      if (!(item.state === "approved" || item.state === "requested")) return false;

      const itemStart = moment(item.startDate).startOf("day");
      const itemEnd = moment(item.endDate).endOf("day");

      return (
        itemStart.isSameOrBefore(mainEnd) &&
        itemEnd.isSameOrAfter(mainStart)
      );
    });

    if (hasOverlappingO) {
      return true;
    }
  }

  const checkCoverage = (date: moment.Moment) =>
    leaveRequests.some((item) => {
      if (item.state === "rejected" || item.state === "cancelled") return false;

      const itemStart = moment(item.startDate).startOf("day");
      const itemEnd = moment(item.endDate).endOf("day");

      const sameType = [
        "A", "B", "C", "D", "E", "F", "G", "H",
        "K", "L", "M", "N", "P", "Q", "R", "S",
        "T", "U", "V",
      ].includes(item.leaveType);

      const exceptionalCoverage =
        (leaveType === "O" || leaveType === "I" || leaveType === "J") &&
        item.leaveType === "S";

      return (
        date.isBetween(itemStart, itemEnd, undefined, "[]") &&
        (sameType || exceptionalCoverage)
      );
    });

  let coverage = false;

  const hasCancelled = leaveRequests.some((item) => {
    if (item.state !== "cancelled") return false;

    const itemStart = moment(item.startDate).startOf("day");
    const itemEnd = moment(item.endDate).endOf("day");

    if (itemStart.isSameOrBefore(mainEnd) && itemEnd.isSameOrAfter(mainStart)) {
      const overlappingItems = leaveRequests.filter((leave) => {
        const leaveStart = moment(leave.startDate).startOf("day");
        const leaveEnd = moment(leave.endDate).endOf("day");
        return (
          leaveStart.isSameOrBefore(mainEnd) &&
          leaveEnd.isSameOrAfter(mainStart)
        );
      });

      const requestedAndSLeave = overlappingItems.some(
        (item) => item.state === "requested" && item.leaveType === "S",
      );

      if (requestedAndSLeave) {
        coverage = true;
        return true;
      }

      const approvedOrRecordedCount = overlappingItems.filter(
        (item) => item.state === "recorded" || item.state === "approved",
      ).length;

      return approvedOrRecordedCount === 1;
    }

    return false;
  });

  if (hasCancelled) {
    return coverage;
  }

  for (
    let date = mainStart.clone();
    date.isSameOrBefore(mainEnd);
    date.add(1, "day")
  ) {
    if (checkCoverage(date)) {
      coverage = true;
      break;
    }
  }

  return coverage;
};

export default myLeaveCoverage;
